import apiClient from '../client';
import { LoginDTO, LoginResponse } from '../../../../shared/types';

export const authService = {
  login: async (credentials: LoginDTO): Promise<LoginResponse> => {
    const data: any = await apiClient.post('/auth/login', credentials);
    return data.data;
  },

  me: async () => {
    const data: any = await apiClient.get('/auth/me');
    return data.data.user;
  },

  logout: async () => {
    const data: any = await apiClient.post('/auth/logout');
    return data.data;
  },

  setup2FA: async (pendingToken: string): Promise<{ qrCodeUrl: string; secret: string }> => {
    const data: any = await apiClient.post('/auth/2fa/setup', { pendingToken });
    return data.data;
  },

  verify2FA: async (pendingToken: string, code: string): Promise<LoginResponse> => {
    const data: any = await apiClient.post('/auth/2fa/verify', { pendingToken, code }, {
      validateStatus: (status) => status === 200 || status === 400,
    });
    if (data.status === 400) {
      throw new Error(data.data?.message || 'Invalid verification code');
    }
    return data.data;
  },
};
